import styled from 'styled-components'

import { helpers } from 'styles'

export const Item = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;

	overflow: hidden;
	overflow-wrap: break-word;

	font-size: 14px;
	color: ${helpers.color.text};
`
